// eslint-disable
<template>
  <div id="google-map" ref="google-map" class="hospitals-google-map"></div>
</template>

<script>
export default {
  name: 'GoogleMap',

  data() {
    return {
      map: null,
      bounds: null,
      markers: []
    }
  },

  props: {
    hospitals: Array,
    clickOnHospital: Function
  },

  mounted() {
    const element = this.$refs['google-map']
    const options = {
      controlSize: 20,
      backgroundColor: '#CCCCCC',
      streetViewControl: false,
      mapTypeControl: false,
      styles: [
        {
          featureType: 'all',
          stylers: [{color: '#CCCCCC'}]
        },
        {
          elementType: 'labels',
          stylers: [{visibility: 'off'}]
        },
        {
          featureType: 'water',
          stylers: [{color: '#FFFFFF'}]
        },
        {
          featureType: 'administrative',
          elementType: 'geometry.stroke',
          stylers: [{color: '#FFFFFF'}]
        }
      ]
    }

    // eslint-disable-next-line
    this.map = new google.maps.Map(element, options)

    // if number of hospitals is 1 then zoom to a bigger map
    if(this.hospitals.length === 1) {
      // eslint-disable-next-line
      this.bounds = new google.maps.LatLngBounds(
        // eslint-disable-next-line
        new google.maps.LatLng(0, -100),
        // eslint-disable-next-line
        new google.maps.LatLng(0, 100)
      )
    // else google maps will automaticaly zoom by the location of hospitals
    } else {
      // eslint-disable-next-line
      this.bounds = new google.maps.LatLngBounds()
    }

    this.hospitals.forEach((hospital) => {
      // eslint-disable-next-line
      const position = new google.maps.LatLng(hospital.latitude, hospital.longitude)

      const content =
        `<div id="gm-info">
          <b>${hospital.name}</b><br />
          <span>${hospital.town} (${hospital.country})</span>
        </div>`

      const locationIcon = {
        path: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 ' +
          '9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
        // eslint-disable-next-line
        anchor: new google.maps.Point(12, 24),
        scale: 0.8,
        strokeColor: '#3FA4D0',
        fillColor: '#3FA4D0',
        fillOpacity: 1
      }

      // eslint-disable-next-line
      const marker = new google.maps.Marker({
        position,
        map: this.map,
        icon: locationIcon
      })

      // eslint-disable-next-line
      const infowindow = new google.maps.InfoWindow({
        content,
        maxWidth: 200
      })

      marker.addListener('click', () => {
        this.clickOnHospital(hospital)
      })

      marker.addListener('mouseover', () => {
        infowindow.open(this.map, marker)
      })

      marker.addListener('mouseout', () => {
        infowindow.close()
      })

      this.markers.push(marker)
      this.map.fitBounds(this.bounds.extend(position))
    })
  }
}
</script>

<style lang="sass">
@import 'raypro_ui/src/styles/base/_variables.sass'

.hospitals-google-map

  &#google-map
    width: 100%
    padding-top: 66.7%
    margin-bottom: 20px
    box-shadow: 0 0 5px $color-shadow
    background-color: $color-panel-bg

</style>


// WEBPACK FOOTER //
// src/components/GoogleMap.vue